import "./AddSection.css";
import bgImage from "../../pages/home/HomeImage/ball3.png";

const AddSection = ({ dark }) => {
  return (
    <aside
      className={`addsection ${dark ? "dark" : "light"}`}
    >
      <div
        className="clubteam"
        // style={{ backgroundImage: `url(${bgImage})` }}
      >
        <div className="overlay" />

        <div className="content">
          <span className="tag">Live Update</span>

          <h1>
            The Club Teams Resume Training in Preparation
          </h1>

          <p>
            Watch your favorite team compete in real-time with full match
            coverage, stats, and highlights.
          </p>

          <button className="cta">Watch Now</button>
        </div>
      </div>
    </aside>
  );
};

export default AddSection;